// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2589":"d6fdf0fb","3202":"99107dfb","5812":"86d85530","9103":"b9ea4917"}[chunkId] + ".css";
};